/**
 * The design ships its own payment logos, which checkout v2 uses in place of the ones Adyen
 * serves. Anything without a file here keeps falling back to the Adyen CDN, so a market whose
 * methods are not drawn yet still shows a logo rather than a gap.
 */
const ICON_DIRECTORY = "/assets/icons/payment-method-icons";

/**
 * Adyen's type or card brand, mapped to the label its file is named after. The names come
 * straight from the design export, so they carry its spacing and casing - `encodeURI` below is
 * what makes them safe in a URL. Keyed on the types `paymentMethodMap` documents, since those
 * are the ones this app actually receives.
 */
const ICON_FILE_LABELS: Record<string, string> = {
    afterpaytouch: "Afterpay",
    amazonPay: "AmazonPay",
    amazon_pay: "AmazonPay",
    amex: "Amex",
    applepay: "ApplePay",
    cup: "UnionPay",
    dankort: "Dankort",
    diners: "DinersClub",
    discover: "Discover",
    googlepay: "google pay",
    grabpay: "Grappay",
    ideal: "Ideal",
    jcb: "JCB",
    klarna: "Klarna",
    klarna_account: "Klarna",
    klarna_paynow: "Klarna",
    maestro: "Maestro",
    mc: "Mastercard",
    mc_applePay: "ApplePay",
    mobilepay: "Mobilepay",
    paypal: "paypal",
    swish: "Swish",
    upi: "UPI",
    vipps: "Vipps",
    visa: "Visa",
};

/** The design's logo for a payment method, or undefined when it does not ship one. */
export const getLocalPaymentIconUrl = (paymentMethodType: string): string | undefined => {
    const label = ICON_FILE_LABELS[paymentMethodType];

    return label ? encodeURI(`${ICON_DIRECTORY}/Type=${label}, Size=48.svg`) : undefined;
};

/** Exported for the test that keeps the mapping honest against the files on disk. */
export const localPaymentIconLabels = ICON_FILE_LABELS;
